import { useSendEvent } from '@domain-group/fe-co-analytics';
import { useEffect, useRef } from 'react';
export var useSendOnce = (condition, eventName, payload) => {
  var eventSent = useRef(false);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  useEffect(() => {
    if (condition && !eventSent.current) {
      sendEvent(eventName, payload);
      eventSent.current = true;
    }
  }, [condition, eventName, payload, sendEvent]);
};